var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user)?[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"cols":"12"}},[_c('user-view-user-info-card',{attrs:{"user-data":_vm.user}})],1)],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }